import React, { useState } from 'react'

import { Collapse } from 'react-bootstrap/lib/Navbar';

import { BatsmanRowHeader, BowlerRowHeader, FowRowHeader } from './RowHeaders';
import { BatsmanRow, BowlerRow, FowRow } from './ScorecardRows';


export default function InningsCollapse({ data }) {
    const [open, setOpen] = useState(true);
    let { extraruns, extra_runs, didnotbat, did_not_bat, batsmen, bowlers, fows, scoresfull, name, scores_full } = data;
    extraruns = extraruns || extra_runs;
    didnotbat = didnotbat || did_not_bat;

    return (
        <div>
            {/* <hr /> */}
            <div onClick={() => setOpen(!open)}
                aria-controls="example-collapse-text"
                className={`scorecard-row header-scorecard ${open ? 'open-scorecard' : ''}`}
                aria-expanded={open}>
                <div>{name}</div>
                <div>
                    {scoresfull || scores_full}
                    <i className={open ? `icon-arrow-up pl-2` : `icon-arrow-down pl-2`}></i>
                </div>
            </div>
            <Collapse in={open}>
                <div id="example-collapse-text text-center">
                    <BatsmanRowHeader />
                    {batsmen.map((batsman, index) =>
                        <BatsmanRow item={batsman} key={index} />
                    )}

                    {extraruns && <div className='scorecard-row'>
                        <div className='rh5'>
                            <div className='header-rh5'>

                                Extras
                            </div>
                            <div>
                                {`nb ${extraruns.noballs}, wd ${extraruns.wides}, b ${extraruns.byes}, lb ${extraruns.legbyes}, pen ${extraruns.penalty}`}
                            </div>
                        </div>
                        <div className='bold'>
                            {extraruns.total}
                        </div>

                    </div>}

                    {didnotbat && <div className='scorecard-row' style={{ flexDirection: "column" }}>
                        <div className="header-rh5">Did not Bat</div>
                        <div>{didnotbat.map(player => `${player.name}, `)}</div>
                    </div>}
                    <hr />
                    <BowlerRowHeader />
                    {bowlers.map((bowler, index) =>
                        <BowlerRow item={bowler} key={index} />
                    )}

                    <hr />
                    <FowRowHeader />
                    {fows.map((fow, index) =>
                        <FowRow item={fow} key={index} />
                    )}

                </div>
            </Collapse>
        </div>
    )
}
